import * as React from 'react'

import { cn } from '@/utilities/ui'

import { inputFocusClasses } from './input'

const Textarea: React.FC<
  {
    ref?: React.Ref<HTMLTextAreaElement>
  } & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = ({ className, ref, ...props }) => {
  return (
    <textarea
      className={cn(
        'flex min-h-20 w-full rounded-xl border border-border bg-input px-3 py-2 font-family-body text-base text-primary placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-reg',
        inputFocusClasses,
        className,
      )}
      ref={ref}
      {...props}
    />
  )
}

export { Textarea }
